import dayjs from "dayjs";
import {EntityBase} from "../../shared/entity/EntityBase";

const COUPON_FIELDS = {
    id: { defaultValue: '' },
    type: { type: Number, defaultValue: 0 },
    onOff: { type: Number, defaultValue: 1 },
    items: { defaultValue: [] },
    title: { defaultValue: 'COUPON' },
    begin: { defaultValue: dayjs().startOf('day').unix() },
    end: { defaultValue: dayjs().endOf('day').unix() },
    use: { type: Number, defaultValue: 1 },
    validPeriod: { type: Number, defaultValue: 1 },
    seed: { type: Number, defaultValue: 1 },
    seedId: { defaultValue: '' }
}

export class CouponEntity extends EntityBase {
    constructor(data = {}) {
        super(data, COUPON_FIELDS);

        this.errors = [
            { condition: () => this.id.trim() === '', message: '쿠폰 이름 입력해주세요.' },
            { condition: () => this.seedId.trim() === '' && this.type === 0, message: '쿠폰 아이디를 입력해주세요.' },
            { condition: () => this.begin > this.end, message: '시작일이 종료일보다 늦습니다.' },
            { condition: () => this.end < dayjs().unix(), message: '종료일이 현재 시간보다 이전입니다.' },
        ]
    }
}